import MtoSector from '@/services/api/mtoSector';

export default {
  namespaced: true,
  state: {
    mtoSectors: [],
    mtoSector: {},
  },
  getters: {
    mtoSectors: state => state.mtoSectors,
    mtoSector: state => state.mtoSector,
  },
  mutations: {
    setMtoSectors: (state, payload) => {
      state.mtoSectors = payload;
    },
    setMtoSector: (state, payload) => {
      state.mtoSector = payload;
    },
  },
  actions: {
    getMtoSectors (state, options = {}) {
      return new Promise((resolve, reject) => {
        MtoSector.getMtoSectors(options)
          .then(({ data }) => {
            state.commit('setMtoSectors', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getMtoSector (state, { id, options = {} }) {
      return new Promise((resolve, reject) => {
        MtoSector.getMtoSector(id, options)
          .then(({ data }) => {
            state.commit('setMtoSector', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    createMtoSector (state, params) {
      return new Promise((resolve, reject) => {
        MtoSector.createMtoSector(params)
          .then(({ data }) => resolve(data))
          .catch(e => reject(e));
      });
    },
    updateMtoSector (state, { id, data }) {
      return new Promise((resolve, reject) => {
        MtoSector.updateMtoSector(id, data)
          .then(({ data }) => {
            state.commit('setMtoSector', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    deleteMtoSector (state, id) {
      return new Promise((resolve, reject) => {
        MtoSector.deleteMtoSector(id)
          .then(response => resolve(response))
          .catch(e => reject(e));
      });
    },
    importDoorphones (state, { id, file }) {
      return new Promise((resolve, reject) => {
        MtoSector.importDoorphones(id, file)
          .then(({ data }) => resolve(data))
          .catch(e => reject(e));
      });
    },
    attachEquipment (state, { id, data }) {
      return new Promise((resolve, reject) => {
        MtoSector.attachEquipment(id, data)
          .then(({ data }) => resolve(data))
          .catch(e => reject(e));
      });
    },
    detachEquipment (state, { id, data }) {
      return new Promise((resolve, reject) => {
        MtoSector.detachEquipment(id, data)
          .then(({ data }) => resolve(data))
          .catch(e => reject(e));
      });
    },
  },
};
